import actions from './actions';

export const reset = () => ({ type: actions.RESET });
export const resetCompany = () => ({ type: actions.RESET_COMPANY });
export const unbusyAll = () => ({ type: actions.UNBUSY });
